import './index.less';

import { FC, useState } from 'react';

import { emailValidateNew, phoneValidate } from '@/utils/ruleValidate';

import { IEmailOrMobile } from '../../types';
import useSendVerificationCode from '../../useSendVerificationCode';
import EmailOrMobileUI from './EmailOrMobileUI';

interface ICompsProps {
  nextStep: (params?: IEmailOrMobile) => void;
  risk_token: string;
  showSecurity: (info: IEmailOrMobile, risk_token: string) => void;
}
const Index: FC<ICompsProps> = ({ nextStep, risk_token, showSecurity }) => {
  const [disabled, setDisabled] = useState(true);

  const [email, setEmail] = useState<string>('');
  const [mobile, setMobile] = useState<string>('');

  const [countryCode, setCountryCode] = useState<string>();
  const [defaultCountryCode, setDefaultCountryCode] = useState('');

  const [currentKey, setCurrentKey] = useState<string>('1');
  const [mobileErr, setMobileErr] = useState<boolean>(false);
  const [emailErr, setEmailErr] = useState<boolean>(false);

  const { sendVerificationCode } = useSendVerificationCode(
    {},
    risk_token,
  ) as any;
  // tab切换
  const onChange = (key: string) => {
    setCurrentKey(key);

    setCountryCode(defaultCountryCode);

    setEmail('');
    setMobile('');
    setDisabled(true);
    setMobileErr(false);
    setEmailErr(false);
  };

  const countrySelect = (e: any) => {
    if (e) {
      if (mobile) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
      setCountryCode(e);
    } else {
      setCountryCode('');
      setDisabled(true);
    }
  };
  const mobileChange = (e: any) => {
    const mobile = e.target.value?.trim?.();
    if (mobile) {
      setMobile(mobile);
      if (phoneValidate(mobile)) {
        setMobileErr(false);
        if (countryCode) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      } else {
        setMobileErr(true);
        setDisabled(true);
      }
    } else {
      setDisabled(true);
      setMobile('');
    }
  };

  const emailChange = (e: any) => {
    const email = e.target.value?.trim?.();
    if (email) {
      setEmail(email);

      if (emailValidateNew(email).status) {
        setEmailErr(false);
        setDisabled(false);
      } else {
        setEmailErr(true);
        setDisabled(true);
      }
    } else {
      setDisabled(true);
      setEmail('');
    }
  };

  // 点击确认
  const onConfirm = () => {
    if ((currentKey === '1' && emailErr) || (currentKey === '2' && mobileErr)) {
      return;
    }
    const info = {
      tapKey: currentKey,
      email,
      country_code: countryCode,
      mobile,
    };
    sendVerificationCode?.(info, (res: any) => {
      if (res?.risk_token) {
        showSecurity(info, res?.risk_token);
      } else {
        nextStep(info); // 打开第二步
      }
    });
  };

  return (
    <EmailOrMobileUI
      currentKey={currentKey}
      onChange={onChange}
      email={email}
      emailChange={emailChange}
      mobile={mobile}
      mobileChange={mobileChange}
      emailErr={emailErr}
      mobileErr={mobileErr}
      disabled={disabled}
      onConfirm={onConfirm}
      countrySelect={countrySelect}
      countryCode={countryCode}
      defaultCountryCode={defaultCountryCode}
      setCountryCode={setCountryCode}
      setDefaultCountryCode={setDefaultCountryCode}
    />
  );
};
export default Index;
